<template>
  <main class="col-md-9 ms-sm-auto col-lg-10 p-0">
    <div class="bg-card p-4 m-3" style="min-height: 70vh">
      <h5 class="text-blue-primary fw-bold pb-2">XARCADE GAMES PRIVACY POLICY</h5>
      <hr class="border-theme">
      <p class="pt-2 text-gray-text">
        This privacy policy covers the information provided to and gathered by
        Xarcade Solutions Sdn. Bhd..
        <br />
        <br />All information provided to or gathered by Xarcade Solutions Sdn.
        Bhd. is controlled by Xarcade Solutions Sdn. Bhd..
      </p>
      <h5 class="pt-3 text-white opacity-75">
        Personal Information Xarcade Solutions Sdn. Bhd. Gathers
      </h5>
      <h6 class="py-3 text-white opacity-75">
        We gather the following types of information:
      </h6>
      <ul class="text-gray-text">
        <li class="pb-3">
          Information provided by you, some sections of Xarcade.io allow you to
          enter personal information, including but not limited to your
          name,your personal ID document, company formation document, and email
          address. You can choose not to provide this information when
          requested, but as a result may be unable to use some functions of the
          site.
        </li>
        <li>
          Information gathered automatically – Certain types of information can
          be gathered automatically when you visit, including your IP address
          and details of the browser you use.
        </li>
      </ul>

      <h6 class="py-3 text-white opacity-75">Using Your Personal Information</h6>
      <ul class="text-gray-text">
        <li>
          We use your personal information to allow you to log into the My
          Account section of this site and during the checkout process of your
          Xarcade stabletoken, XAR, your username and wallet address will be
          retrieved . Your name and address, gathered during the checkout
          process, are securely stored and encrypted for legal auditing purposes
          only as per the Data Protection Act and Freedom of Information Act.
        </li>
      </ul>

      <h6 class="py-3 text-white opacity-75">VAT  & Other Tax Information Requirements</h6>
      <p class="text-gray-text">
        In order to comply with VAT and other tax legislations, we are required to verify your country of residence, which we will do by gathering your home address, telephone number and IP address from you. This information will only be used for that purpose only. Please ensure that you give accurate information, since otherwise we will be obliged to charge you the highest level of applicable VAT or Tax.
      </p>

      <h6 class="py-3 text-white opacity-75">Disclosure</h6>
      <p class="text-gray-text">
       Your information may be available to employees of Xarcade Solutions Sdn. Bhd. in order to provide helpdesk support and other feedback. We will not disclose your information to any third parties except:
      </p>
      <ul class="text-gray-text">
        <li class="pb-2">When required by law to do so.</li>
        <li class="pb-2">In connection with any legal proceedings.</li>
        <li class="">In order to establish, exercise or defend our legal rights.</li>
      </ul>

      
      <h6 class="py-3 text-white opacity-75">Security Of Your Personal Information.</h6>
      <p class="text-gray-text">
        No sensitive personal information is handled directly by this website. All credit card and other financial transactions are processed entirely by a secure third party and your financial details are not made available to Xarcade Solutions Sdn. Bhd..
         </p>

      
      <h6 class="py-3 text-white opacity-75">Your Rights</h6>
      <p class="text-gray-text">
       Xarcade Solutions Sdn. Bhd. may provide links to third-party websites, but we do not provide any identifiable or sensitive information to these sites.
  </p>

    </div>
  </main>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: 'viewLegalPrivacyPolicy',
});
</script>
